import React, { useState } from 'react';
import { ChevronDownIcon, ChevronUpIcon } from 'lucide-react';
interface Chapter {
  number: number;
  emoji: string;
  title: string;
  items: string[];
}
export function Chapters() {
  const [openChapter, setOpenChapter] = useState<number | null>(null);
  const chapters: Chapter[] = [{
    number: 1,
    emoji: '🏭',
    title: 'La realidad del laboratorio que nadie te cuenta',
    items: ['Cómo funciona realmente un laboratorio dental', 'Relación técnico–odontólogo', 'Tipos de laboratorios y oportunidades', 'Errores comunes de principiantes', 'Comunicación profesional efectiva', 'Lectura correcta de órdenes de trabajo', 'Lo que el instituto no te enseñó']
  }, {
    number: 2,
    emoji: '🧪',
    title: 'Materiales dentales sin errores',
    items: ['Yesos dentales', 'Resinas acrílicas', 'Siliconas de impresión', 'Ceras dentales', 'Cerámicas feldespáticas', 'Zirconia', 'Metales dentales', 'Tabla maestra de materiales y usos']
  }, {
    number: 3,
    emoji: '🦷',
    title: 'Prótesis removibles paso a paso',
    items: ['Prótesis completas', 'Montaje en articulador', 'Rodetes de oclusión', 'Selección y montaje dentario', 'Enmuflado y prensado', 'Pulido y terminado', 'Control de calidad final', 'Solución de errores frecuentes']
  }, {
    number: 4,
    emoji: '👑',
    title: 'Prótesis fija: coronas y puentes',
    items: ['Muñones y troqueles', 'Encerado diagnóstico', 'Cofias metálicas', 'Estratificación cerámica', 'Pónticos y conectores', 'Ajuste oclusal', 'Zirconia y disilicato', 'Checklist profesional de entrega']
  }, {
    number: 5,
    emoji: '💻',
    title: 'Introducción al flujo digital',
    items: ['Escaneo digital', 'Archivos STL', 'CAD vs CAM', 'Software para técnicos dentales', 'Flujo digital completo', 'Herramientas gratuitas para comenzar', 'Integración digital en laboratorios tradicionales']
  }, {
    number: 6,
    emoji: '🚀',
    title: 'CAD/CAM y Zirconia',
    items: ['Fresadoras y tecnologías actuales', 'Tipos de zirconia', 'Diseño digital CAD', 'Fresado CAM', 'Sinterizado', 'Caracterización estética', 'Impresión 3D dental', 'Cómo destacarte como técnico digital']
  }, {
    number: 7,
    emoji: '🏢',
    title: 'Montá tu propio laboratorio',
    items: ['Equipamiento indispensable', 'Costos y presupuestos', 'Gestión de trabajos', 'Cómo conseguir odontólogos clientes', 'Organización profesional', 'Independizarte sin errores']
  }];
  const toggleChapter = (index: number) => {
    setOpenChapter(openChapter === index ? null : index);
  };
  return <section className="w-full px-4 py-12 bg-gray-50" data-id="element-32">
      <div className="max-w-4xl mx-auto" data-id="element-33">
        <h2 className="text-2xl md:text-3xl font-bold text-center text-gray-900 mb-8" data-id="element-34">
          CAPÍTULOS
        </h2>

        <div className="space-y-3" data-id="element-35">
          {chapters.map((chapter, index) => <div key={index} className="bg-white rounded-lg shadow-md overflow-hidden" data-id="element-36">
              <button onClick={() => toggleChapter(index)} className="w-full flex items-center justify-between p-5 text-left hover:bg-gray-50 transition-colors" data-id="element-37">
                <div className="flex-1" data-id="element-38">
                  <span className="text-green-600 font-bold text-sm" data-id="element-39">
                    {chapter.emoji} CAPÍTULO {chapter.number}
                  </span>
                  <h3 className="text-lg font-semibold text-gray-900 mt-1" data-id="element-40">
                    {chapter.title}
                  </h3>
                </div>
                {openChapter === index ? <ChevronUpIcon className="w-6 h-6 text-gray-500 flex-shrink-0" data-id="element-41" /> : <ChevronDownIcon className="w-6 h-6 text-gray-500 flex-shrink-0" data-id="element-42" />}
              </button>

              {openChapter === index && <div className="px-5 pb-5 pt-2 bg-gray-50" data-id="element-43">
                  <ul className="space-y-2" data-id="element-44">
                    {chapter.items.map((item, itemIndex) => <li key={itemIndex} className="flex items-start gap-2" data-id="element-45">
                        <span className="text-green-600 mt-1" data-id="element-46">✅</span>
                        <span className="text-gray-700" data-id="element-47">{item}</span>
                      </li>)}
                  </ul>
                </div>}
            </div>)}
        </div>
      </div>
    </section>;
}